module.exports = __webpack_public_path__ + "media/images/fantasy_logo_fr-c19f7294879f86efc953cd1b99e73506.svg";